import { Button, Flex, useMediaQuery } from "@wayflyer/flyui";
import type { UseUploadManagerReturn } from "@wayflyer/flyui";
import type { BankConnectionSchema, LogoLoadingState } from "bankconnect";
import { useIntl } from "react-intl";

import { AddStatementsButton } from "../bank-statements/add-statements-button";
import { BankAccountsList } from "../accounts-list/accounts-list";
import { ExtractedStatements } from "../extracted-statements/extracted-statements";
import { MESSAGES } from "../message-definitions";
import type { SelectedAccount } from "../utils";

import type { BankStatementUpload } from "../../hooks/use-bank-accounts-upload-manager";
import type { ExtractionStatusItem } from "../../hooks/use-bank-statement-extraction-statuses";
import type { ExtractedAccountEntry } from "../accounts-list/extracted-account-entry";

type BankAccountsFilledStateProps = {
  bankingConnections: BankConnectionSchema[];
  extractedAccounts: ExtractedAccountEntry[];
  pendingOrFailedExtractions: ExtractionStatusItem[];
  logoLoadingStates: LogoLoadingState;
  onSelectAccount: (account: SelectedAccount) => void;
  onOpenConnectModal: () => void;
  onFilesAdded: UseUploadManagerReturn<BankStatementUpload>["onFilesAdded"];
};

export const BankAccountsFilledState = ({
  bankingConnections,
  extractedAccounts,
  pendingOrFailedExtractions,
  logoLoadingStates,
  onSelectAccount,
  onOpenConnectModal,
  onFilesAdded,
}: BankAccountsFilledStateProps) => {
  const intl = useIntl();
  const query = useMediaQuery();
  const isMobile = query("sm").windowLte;

  return (
    <Flex direction="column" gap="10">
      <Flex direction={isMobile ? "column" : "row"} gap="2">
        <Button variant="Secondary" fullWidth={isMobile} onClick={onOpenConnectModal}>
          {intl.formatMessage(MESSAGES.addAccountInstantly)}
        </Button>
        <AddStatementsButton onFilesAdded={onFilesAdded} fullWidth={isMobile} />
      </Flex>

      <BankAccountsList
        bankingConnections={bankingConnections}
        extractedAccounts={extractedAccounts}
        logoLoadingStates={logoLoadingStates}
        onSelectAccount={onSelectAccount}
      />

      <ExtractedStatements items={pendingOrFailedExtractions} />
    </Flex>
  );
};
